import { render, staticRenderFns } from "./ContactPortalLinkCopy.vue?vue&type=template&id=66a5f2ac"
import script from "./ContactPortalLinkCopy.vue?vue&type=script&lang=js"
export * from "./ContactPortalLinkCopy.vue?vue&type=script&lang=js"
import style0 from "./ContactPortalLinkCopy.vue?vue&type=style&index=0&id=66a5f2ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports